import { render, staticRenderFns } from "./PreviouslyPurchasedItems.vue?vue&type=template&id=a7d3809e&scoped=true&lang=pug&"
import script from "./PreviouslyPurchasedItems.vue?vue&type=script&lang=js&"
export * from "./PreviouslyPurchasedItems.vue?vue&type=script&lang=js&"
import style0 from "./PreviouslyPurchasedItems.vue?vue&type=style&index=0&id=a7d3809e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d3809e",
  null
  
)

/* custom blocks */
import block0 from "./PreviouslyPurchasedItems.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports